
const CommonConstant : any =  {
    localEnvironemt: "local",
    AOGI: "AOGI"
};

export default CommonConstant;